/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type OverviewFavorites_tradeFirm = {
    readonly serviceId: string | null;
    readonly publicProfile: {
        readonly urlLabel: string | null;
        readonly portfoliosInflated: ReadonlyArray<{
            readonly items: {
                readonly edges: ReadonlyArray<{
                    readonly node: {
                        readonly item: {
                            readonly serviceId: string | null;
                            readonly title: string | null;
                            readonly seller: {
                                readonly serviceId: string | null;
                            } | null;
                            readonly isContemporary: boolean | null;
                            readonly isCustomizable: boolean | null;
                            readonly isNewAndMadeToOrder: boolean | null;
                            readonly classification: {
                                readonly categories: ReadonlyArray<{
                                    readonly category: {
                                        readonly key: string | null;
                                        readonly browseUrl: string | null;
                                    } | null;
                                } | null> | null;
                            } | null;
                            readonly pricing: {
                                readonly amount: {
                                    readonly amount: number | null;
                                } | null;
                                readonly netPrice: {
                                    readonly amount: number | null;
                                } | null;
                                readonly salePrice: {
                                    readonly amount: number | null;
                                } | null;
                            } | null;
                            readonly " $fragmentRefs": FragmentRefs<"OverviewFavoriteItem_item">;
                        } | null;
                    } | null;
                } | null> | null;
            } | null;
        } | null> | null;
    } | null;
    readonly " $refType": "OverviewFavorites_tradeFirm";
};
export type OverviewFavorites_tradeFirm$data = OverviewFavorites_tradeFirm;
export type OverviewFavorites_tradeFirm$key = {
    readonly " $data"?: OverviewFavorites_tradeFirm$data;
    readonly " $fragmentRefs": FragmentRefs<"OverviewFavorites_tradeFirm">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
},
v1 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount",
    "args": null,
    "storageKey": null
  }
];
return {
  "kind": "Fragment",
  "name": "OverviewFavorites_tradeFirm",
  "type": "TradeFirmType",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "publicProfile",
      "storageKey": null,
      "args": null,
      "concreteType": "TradeFirmPublicProfileType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "urlLabel",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "portfoliosInflated",
          "storageKey": null,
          "args": null,
          "concreteType": "PortfolioV2",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "items",
              "storageKey": "items(first:6)",
              "args": [
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 6
                }
              ],
              "concreteType": "PortfolioItemsConnection",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "PortfolioItemsEdge",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "PortfolioItemV2",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "item",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "Item",
                          "plural": false,
                          "selections": [
                            (v0/*: any*/),
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "title",
                              "args": null,
                              "storageKey": null
                            },
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "seller",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "Seller",
                              "plural": false,
                              "selections": [
                                (v0/*: any*/)
                              ]
                            },
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "isContemporary",
                              "args": null,
                              "storageKey": null
                            },
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "isCustomizable",
                              "args": null,
                              "storageKey": null
                            },
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "isNewAndMadeToOrder",
                              "args": null,
                              "storageKey": null
                            },
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "classification",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "ItemClassification",
                              "plural": false,
                              "selections": [
                                {
                                  "kind": "LinkedField",
                                  "alias": null,
                                  "name": "categories",
                                  "storageKey": null,
                                  "args": null,
                                  "concreteType": "ItemCategory",
                                  "plural": true,
                                  "selections": [
                                    {
                                      "kind": "LinkedField",
                                      "alias": null,
                                      "name": "category",
                                      "storageKey": null,
                                      "args": null,
                                      "concreteType": "Category",
                                      "plural": false,
                                      "selections": [
                                        {
                                          "kind": "ScalarField",
                                          "alias": null,
                                          "name": "key",
                                          "args": null,
                                          "storageKey": null
                                        },
                                        {
                                          "kind": "ScalarField",
                                          "alias": null,
                                          "name": "browseUrl",
                                          "args": null,
                                          "storageKey": null
                                        }
                                      ]
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "pricing",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "ItemPricing",
                              "plural": false,
                              "selections": [
                                {
                                  "kind": "LinkedField",
                                  "alias": null,
                                  "name": "amount",
                                  "storageKey": null,
                                  "args": null,
                                  "concreteType": "FinancialAmount",
                                  "plural": false,
                                  "selections": (v1/*: any*/)
                                },
                                {
                                  "kind": "LinkedField",
                                  "alias": null,
                                  "name": "netPrice",
                                  "storageKey": null,
                                  "args": null,
                                  "concreteType": "FinancialAmount",
                                  "plural": false,
                                  "selections": (v1/*: any*/)
                                },
                                {
                                  "kind": "LinkedField",
                                  "alias": null,
                                  "name": "salePrice",
                                  "storageKey": null,
                                  "args": null,
                                  "concreteType": "FinancialAmount",
                                  "plural": false,
                                  "selections": (v1/*: any*/)
                                }
                              ]
                            },
                            {
                              "kind": "FragmentSpread",
                              "name": "OverviewFavoriteItem_item",
                              "args": null
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = 'f5d53b77526f48ecdb539e4541e65f5c';
export default node;
